import { FieldErrors, UseFormRegister } from "react-hook-form";
import styled from "styled-components";
import {
  ErrorMessage,
  FormGroup,
  Label,
  Select,
} from "../../../components/common/Form";
import { Member } from "../../../stores/user.store";
import type { CourseType } from "../../../types/course";
import type { CompanionWithStatus } from "../hooks/useAvailableCompanions";
import { InfoBox, InfoLabel, InfoValue } from "./ReadOnlyInfo";

type FormInputs = {
  type: CourseType;
  level: string;
  companion_id: string;
};

type Props = {
  isRequired: boolean;
  isReadOnly: boolean;
  currentCompanion?: Member | null;
  availableCompanions: CompanionWithStatus[];
  register: UseFormRegister<FormInputs>;
  errors: FieldErrors<FormInputs>;
};

const HelpText = styled.div`
  font-size: 13px;
  color: #666;
  margin-top: 8px;
  line-height: 1.5;

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const CompanionField = ({
  isRequired,
  isReadOnly,
  currentCompanion,
  availableCompanions,
  register,
  errors,
}: Props) => {
  if (isReadOnly) {
    return (
      <InfoBox>
        <InfoLabel>Accompagnatore</InfoLabel>
        <InfoValue>
          {currentCompanion
            ? `${currentCompanion.first_name} ${currentCompanion.last_name}`
            : "Nessun accompagnatore"}
        </InfoValue>
      </InfoBox>
    );
  }

  const formatCompanionName = (companion: CompanionWithStatus) => {
    const name = `${companion.first_name} ${companion.last_name}`;
    return companion.hasSeasonSubscription ? `${name} ✓ Tesserato` : name;
  };

  return (
    <FormGroup>
      <Label htmlFor="companion_id">
        Accompagnatore ({isRequired ? "obbligatorio" : "opzionale"})
      </Label>
      <Select
        id="companion_id"
        $hasError={!!errors.companion_id}
        {...register("companion_id", {
          required: false,
        })}
      >
        <option value="">Nessun accompagnatore</option>
        {availableCompanions.map((companion) => (
          <option key={companion.id} value={companion.id}>
            {formatCompanionName(companion)}
          </option>
        ))}
      </Select>
      {errors.companion_id && (
        <ErrorMessage>{errors.companion_id.message}</ErrorMessage>
      )}
      <HelpText>
        L'accompagnatore deve essere tra i membri dell'account. Se desidera
        sciare con lo sconto del club, deve avere una tessera CO2 per la
        stagione corrente.{" "}
        <a href="/account/members">
          Non trovi il familiare? Gestisci familiari
        </a>
      </HelpText>
    </FormGroup>
  );
};
